import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { SessionProvider } from "./lib/session.tsx";
import App from "./App.tsx";
import { initTheme } from "./lib/theme.ts";
import "./styles.css";
import "./landing.css";
import "./paywall.css";

initTheme();

const container = document.getElementById("root");
if (!container) throw new Error("Root element missing from index.html.");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);

// Registered after first paint so it never delays initial load. Only the
// static shell is cached — see public/sw.js for exactly what that covers.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Non-fatal: the app works identically without offline support.
    });
  });
}
